import * as exercisesConstants from './exercises';
export var exercises = exercisesConstants;
export var issueCategories = [{
  key: 'not-accepted-right-answer',
  label: 'My answer is correct, but it is not accepted',
  value: 'My answer is correct, but it is not accepted'
}, {
  key: 'feedback-not-helpful',
  label: 'The feedback on my submission(s) is not helpful',
  value: 'The feedback on my submission(s) is not helpful'
}, {
  key: 'hint-not-helpful',
  label: 'The hint is not helpful',
  value: 'The hint is not helpful'
}, {
  key: 'typo-ex',
  label: 'There is a typo in this exercise',
  value: 'There is a typo in this exercise'
}, {
  key: 'other',
  label: 'Other',
  value: 'Other'
}];